import React from 'react';
import { Link } from 'react-router-dom';
import './css/SearchOptions.css';
import { TYRI, HOT } from '../../Utils/Constants/HomePageConstants';
import { ReactComponent as Hot } from '../../images/hot_tour.svg';

function SearchOptions() {
  return (
    <div className="ho_serch_type_w">
      <div className="ho_serch_type">
        <button
          type="button"
          className="bm_text_18 ho_serch_type_item_selected"
        >
          {TYRI}
        </button>
        <Link
          to="/hot"
          target="_blank"
          className="wm_text_18 ho_serch_type_item ho_hot_item"
        >
          <Hot className="ho_hot_icon" />
          {HOT}
        </Link>
      </div>
    </div>
  );
}

export default SearchOptions;
